export default __webpack_public_path__ + "static/media/avnatiFinancee.112e5b78.jpeg";